export enum State {
  INITIAL,
  LOADED,
  ERROR,
}

interface OneWebWindow extends Window {
  analytics_ow:
    | {
        vars: {
          flyout_config: any | undefined;
        };
      }
    | undefined;
}
export interface ABContextParams {
  variableName: string;
  eventName: string;
}
export class ABContext {
  public state: State = State.INITIAL;
  public value: any = null;
  private static readonly oneWebWindow: OneWebWindow = parent.window as any;
  private static instance: ABContext;
  private variableName: string | undefined;

  public static initialize({ variableName, eventName }: ABContextParams): ABContext {
    //Here we initialize the ABContext with the needed info and configs, and return the singleton instance
    if (!ABContext.instance) {
      ABContext.instance = new ABContext();
    }
    if (variableName) {
      ABContext.instance.variableName = variableName;
      // If the analytics object is present we can proceed with the setLoaded state change
      // Else we add a event listener for the custom event defined
      if (
        ABContext.oneWebWindow.analytics_ow?.vars?.flyout_config?.[variableName] !== undefined &&
        ABContext.oneWebWindow.analytics_ow?.vars?.flyout_config?.[variableName] !== void 0
      ) {
        ABContext.instance.setLoaded();
      } else {
        const webComponent = document.querySelector('vmos-flyout') || document;
        webComponent?.addEventListener(eventName, ABContext.instance.setLoaded);
      }
    }
    // As a safeguard we also listen to the load event on the window page where
    // our variable is stored
    ABContext.oneWebWindow.addEventListener('load', () => {
      const timeout = ABContext.instance.checkIfVariableIsReady(variableName);
      return () => {
        clearTimeout(timeout);
      };
    });
    return ABContext.instance;
  }

  public setState(state: State): void {
    ABContext.instance.state = state;
  }

  public setError(): void {
    ABContext.instance.setState(State.ERROR);
  }

  public setLoaded(): void {
    ABContext.instance.setState(State.LOADED);
    ABContext.instance.value =
      ABContext.instance.variableName &&
      ABContext.oneWebWindow.analytics_ow?.vars?.flyout_config?.[ABContext.instance.variableName];
  }

  public checkIfVariableIsReady(variableName: string): number {
    // If after 3sec the analytics vars are still not present we set the state to error
    return setTimeout(() => {
      if (
        ABContext.oneWebWindow.analytics_ow?.vars?.flyout_config?.[variableName] === undefined ||
        ABContext.oneWebWindow.analytics_ow?.vars?.flyout_config?.[variableName] === void 0
      ) {
        ABContext.instance.setError();
      }
    }, 3000);
  }
}
